<template>
  <div>
    <div class="row">
      <div class="col-md-6">
        <h2 class="text-primary" style="margin-bottom: 0px">
          <i class="fas fa-shopping-cart" /> Venda
        </h2>
      </div>
    </div>

    <hr />
    <br />
    <order-form ref="orderForm" :id="this.$route.params.id" :operation="1" />
  </div>
</template>

<script>
import OrderForm from "@/components/forms/order/OrderForm";

export default {
  components: { OrderForm },

  async mounted() {
    if (this.$route.params.id) {
      await this.$refs.orderForm
        .loadOrder(this.$route.params.id)
        .then((response) => {
          //
        });
    }

    if (this.$route.query.fromOrder) {
      // laod products
      //this.$refs.orderForm.loadProductsFromOrder(this.$route.query.fromOrder)
    }

    this.$store.commit("pageHasLoaded");
  },
};
</script>

<style>
</style>